module.exports = __webpack_public_path__ + "static/media/beaconHome-2560w.50955e58.jpg";